import _ from 'lodash'
import router from '@/router'

const DEFAULT_QUARANTINE_PERIOD = 8
const SPECIAL_QUARANTINE_PERIOD = 15

export default {
  data () {
    return {
      DEFAULT_QUARANTINE_PERIOD,
      SPECIAL_QUARANTINE_PERIOD
    }
  },
  computed: {
    isValidQuarantinePeriod: function () {
      const period = this.getQuarantinePeriod(router.currentRoute.query.start)
      return (this.$dayjs(router.currentRoute.query.end).diff(router.currentRoute.query.start, 'day') >= period)
    }
  },
  methods: {
    checkQuarantineHotel: function (quarantineKey) {
      return !_.isEmpty(quarantineKey)
    },
    isSpecialPeriod: function (startDate) {
      const period = {
        start: '2022-02-14',
        end: '2022-03-06'
      }
      return this.$dayjs(startDate).diff(period.start, 'day') >= 0 && this.$dayjs(startDate).diff(period.end, 'day') <= 0
    },
    getQuarantinePeriod: function (startDate) {
      if (this.isSpecialPeriod(startDate)) {
        return SPECIAL_QUARANTINE_PERIOD
      }
      return DEFAULT_QUARANTINE_PERIOD
    }
  }
}
